import { render } from "./RegisterPage.vue?vue&type=template&id=23c0e686&scoped=true"
import script from "./RegisterPage.vue?vue&type=script&lang=js"
export * from "./RegisterPage.vue?vue&type=script&lang=js"

import "./RegisterPage.vue?vue&type=style&index=0&id=23c0e686&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-23c0e686"

export default script